import React, { useState, useRef, useEffect } from "react";
import "../../screens/Sportsbook/Sportsbook.css"; //"../Sportsbook.css";
import { Row, Col, Card, Button, Form, Container } from "react-bootstrap";
import "../../css/main.css";
import NewPlayerBetSlip from "../NewPlayerBetSlip";
import { useSelector, useDispatch } from "react-redux";
import { RiFileList3Line } from "react-icons/ri";
import { Actions } from "../../redux/Actions/Actions";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import NotFound from "../../screens/NotFound";
import { PlayerCardImageUrl } from "../../constant/Environment";
import Toaster from "../Toast";
import Loader from "../Loader";
import { isMobile } from "react-device-detect";

import { ErrorToast } from "../Toast/message";
import { getdate } from "../../Utility/functions/Helper";

import MarketingPopup from "../MarketingPopup";
import { PageVisit, RemovePlayer } from "../../Utility/API";
import { AddPlayer } from "../../Utility/API";
import { BsFillCaretDownFill } from "react-icons/bs";
import { BsFillCaretUpFill } from "react-icons/bs";
import MultiPlayerBetSlip from "../MultiPlayerBetSlip";

const MultiPlayerCard = (props) => {
  const {
    playerList,
    searchQuery,
    activeTabIndex,
    activeTabName,
    activeMatchTabName,
    activeshortTabName,
  } = props;
  const [card, setcard] = useState([]);
  const dispatch = useDispatch();
  const [counter, setcounter] = useState(1);
  const state = useSelector((state) => state);
  const { selectedBetslipBtn } = state.betslip;
  const [homeTeam, setHomeTeam] = useState("");
  const [awayTeam, setAwayTeam] = useState("");
  const [matchtime, setMatchtime] = useState("");
  const [modalvisible, setModalvisible] = useState(false);
  const [newmarket, setNewmarket] = useState([]);
  const [multiLinemarket, setMultiLineMarket] = useState([]);
  const [expandedPlayers, setExpandedPlayers] = useState({});
  const [activeMarket, setActiveMarket] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    if (activeMatchTabName) {
      const splitMatch = activeMatchTabName.split(" v/s ");
      const home = splitMatch[0];
      const away = splitMatch.length > 1 ? splitMatch[1] : "";
      setHomeTeam(home);
      setAwayTeam(away);
    }
  });

  const triggermodal = () => {
    setModalvisible(true);
  };

  const modalclose = () => {
    setModalvisible(false);
  };

  useEffect(() => {
    PageVisit(state?.auth?.user?.idUser || "", "home");
  }, []);

  useEffect(() => {
    if (activeTabName && activeMatchTabName) {
      const alldates = getdate(playerList);

      alldates.map((item, index) => {
        if (
          activeMatchTabName == item.games &&
          activeTabName == item.shortdate
        ) {
          const matchDateTime = moment(item?.name);
          const maindate = matchDateTime.format("ddd, MMM DD h:mm A");
          setMatchtime(maindate);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (playerList?.length > 0) {
      const currentMainItem = playerList.find(
        (item) => item.eventName == activeMatchTabName
      );

      if (currentMainItem?.markets?.length > 0) {
        setActiveMarket(currentMainItem?.markets[0]?.market_id);
      }
    }
  }, [activeMatchTabName, activeTabName]);

  const handlechangePlayer = (btnName, element, playerId, eventId) => {
    if (state?.betslip?.isVisible == false) {
      dispatch({
        type: Actions.RECECIPT_VISIBLE,
        data: true,
      });
    }

    if (state?.betslip?.dateMsg == true) {
      dispatch({
        type: Actions.DATE_MSG,
        data: false,
      });
    }

    if (state?.betslip?.isSelected == true) {
      dispatch({
        type: Actions.SELECTED,
        data: false,
      });
    }

    if (state?.betslip.isteam == true && state?.betslip.betslips.length < 10) {
      dispatch({
        type: Actions.TEAMCHECK,
        data: false,
      });
    }

    if (state?.betslip.Message == false) {
      dispatch({
        type: Actions.CLEAR_MSSG,
        data: true,
      });
    }

    let index = selectedBetslipBtn.indexOf(btnName);
    setcounter(1);

    if (index == -1) {
      if (length <= 9) {
        const existingIndex = state.betslip.betslips.findIndex(
          (bet) =>
            bet.playerId == playerId &&
            bet.marketId == element.marketId &&
            bet.id === element.id
        );

        if (existingIndex > -1) {
          // remove old bet first
          dispatch({
            type: Actions.REMOVE_SELECTED_BETSLIP_ODD,
            removeEleIndex: existingIndex,
            playerId,
            marketId: element.marketId,
            id: element.id, // pass the unique odd id
          });
        }

        if (index > -1) {
          dispatch({
            type: Actions.REMOVE_SELECTED_BETSLIP,
            removeEleIndex: index,
          });
        } else {
          dispatch({
            type: Actions.SELECTED_BETSLIP,
            data: {
              ...element,
              displayName: "",
              isMore: false,
              isLess: false,
              playerId,
              eventId,
              isShowing: false,
            },
            selectedBtn: btnName,
          });
          // AddPlayer(
          //   state?.auth?.user?.idUser || "",
          //   element.single_event,
          //   element.name,
          //   element.single_event,
          //   element.points,
          //   element.statAbv
          // );
        }
      } else {
        ErrorToast("Maximum of 10 players allowed per contest.");
      }
    } else {
      dispatch({
        type: Actions.REMOVE_SELECTED_BETSLIP,
        removeEleIndex: index,
      });
      RemovePlayer(
        state?.auth?.user?.idUser || "",
        element.single_event,
        element.name,
        element.single_event,
        element.points,
        element.statAbv
      );
      setNewmarket([]);
    }
  };

  let length = state.betslip.betslips.length;

  useEffect(() => {
    const relatedmarket = new Set();

    state.betslip.betslips.forEach((item) => {
      if (Array.isArray(item.correlatedmarket)) {
        item.correlatedmarket.forEach((value) => {
          relatedmarket.add(`${item.playerId}_${item.eventId}_${value}`);
        });
      } else if (typeof item.correlatedmarket === "string") {
      }
    });
    const uniqueMarketArray = Array.from(relatedmarket);
    setNewmarket(uniqueMarketArray);
  }, [state.betslip.betslips]);

  useEffect(() => {
    setTimeout(() => {
      setcounter(0);
    }, 2000);
  }, [counter]);

  <style>
    {`
    div::-webkit-scrollbar {
      display: none;
    }
  `}
  </style>;

  return (
    <Row>
      <Toaster />
      {playerList.length > 0 ? (
        <Col sm="12" lg="8">
          <div
            className="midbody bodyborder"
            style={{
              backgroundColor: "#E4E4E4",
              borderRadius: "10px",
              // padding: "20px",
              border: "1px solid rgb(84, 103, 121)",
              marginLeft: "10px",
            }}
          >
            <MarketingPopup />

            <div className="tab-content" style={{ padding: "0px" }}>
              {awayTeam != "" ? (
                <div class="title-card-header">
                  <div class="row">
                    <div class="col-md-8 col-7 col70">
                      <p
                        class="flex-centert"
                        style={{
                          justifyContent: "left",
                          paddingLeft: "15px",
                          fontSize: "14px!important",
                        }}
                      >
                        {/* <span class="border-button">Home</span> */}
                        {awayTeam} <span style={{ color: "#C02640" }}>@</span>{" "}
                        {homeTeam}
                      </p>
                    </div>
                    {/* <div class="text-center col-md-4 col-2">
                      <p> vs </p>
                    </div> */}
                    <div class="col-md-4 col-5 col30">
                      <p
                        class="flex-centert flex-md-right matchtime"
                        style={{
                          justifyContent: "right",
                          paddingRight: "5px",
                          color: "#0D3862!important",
                        }}
                      >
                        {matchtime}
                        {/* <span class="border-button">Away</span> */}
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div class="title-card-header">
                  <div class="row">
                    <div class="col-md-8 col-7">
                      <p
                        class="flex-centert"
                        style={{
                          justifyContent: "left",
                          paddingLeft: "15px",
                          fontSize: "14px!important",
                        }}
                      >
                        {awayTeam} <span style={{ color: "#C02640" }}></span>{" "}
                        {homeTeam}
                      </p>
                    </div>
                    {/* <div class="text-center col-md-4 col-2">
                      <p> vs </p>
                    </div> */}
                    <div class="col-md-4 col-5">
                      <p
                        class="flex-centert flex-md-right matchtime"
                        style={{
                          justifyContent: "right",
                          paddingRight: "15px",
                          color: "#0D3862!important",
                        }}
                      >
                        {matchtime}
                        {/* <span class="border-button">Away</span> */}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="gyuse-4"
                style={{
                  height: "600px",
                  overflowX: "hidden",
                  overflowY: "auto",
                }}
              >
                <Col lg="12" xs="12" className="smallbetoption   m-hide">
                  <Row style={{ marginTop: "3px" }}>
                    <Col lg="2" xs="2"></Col>
                    <Col lg="2" xs="1">
                      <h5
                        className="mainbet"
                        style={{
                          border: "2px solid black",
                          textAlign: "center",
                          color: "black",
                          borderRadius: "50%",
                          height: "30px",
                          width: "30px",
                          padding: "4px",
                        }}
                      >
                        {" "}
                        <b>{length > 0 && length}</b>
                      </h5>
                    </Col>
                    <Col lg="6" xs="5">
                      <h5
                        style={{
                          color: "black",
                          marginTop: "7px",
                          fontWeight: "500",
                          fontSize: "17px",
                        }}
                      >
                        player selected
                      </h5>
                    </Col>
                    <Col lg="4" xs="3">
                      <Link to={`/MobileBetSlip`}>
                        <h6
                          style={{
                            color: "black",
                            fontSize: "15px",
                            float: "right",
                            marginTop: "8px",
                            fontWeight: "600",
                          }}
                        >
                          Finalize{" "}
                          <i
                            className="fa fa-angle-double-up"
                            style={{ fontSize: "17px", fontWeight: "600" }}
                          ></i>
                        </h6>
                      </Link>
                    </Col>
                    <Col lg="2" xs="1"></Col>
                  </Row>
                </Col>

                {playerList?.map((mainitem, index) => {
                  const awayteam = mainitem?.teamA?.abv || "";
                  const hometeam = mainitem?.teamH?.abv || "";
                  const teamid = mainitem?.teamH?.teamId || "";
                  const d = mainitem.openDate;
                  const formattedDate = moment(mainitem?.openDate).format(
                    "ddd, MMM D h:mm A"
                  );
                  const gameTime = moment(d).format("LLL");

                  const away = mainitem?.awayPlayers || [];
                  const home = mainitem?.homePlayers || [];
                  const fullist = home.concat(away);
                  const CombineId = `${mainitem.id}_${index}`;

                  return (
                    <div key={mainitem.id}>
                      {(() => {
                        const visibleMarkets =
                          mainitem.markets?.filter(
                            (market) =>
                              activeMatchTabName === mainitem.eventName &&
                              activeTabName === mainitem.displayDate
                          ) || [];

                        return (
                          visibleMarkets.length > 0 && (
                            <div
                              className="flex gap-2 p-2"
                              style={{
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                scrollbarWidth: "none", // Firefox
                                msOverflowStyle: "none", // IE/Edge
                                display: "flex",
                              }}
                            >
                              {visibleMarkets.map((market) => (
                                <button
                                  key={market.id}
                                  onClick={() =>
                                    setActiveMarket(market.market_id)
                                  }
                                  style={{
                                    flex: "0 0 auto",
                                    minWidth: "120px",
                                    padding: "4px 8px",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    border: "1px solid #ccc",
                                    backgroundColor:
                                      activeMarket === market.market_id
                                        ? "#1976d2"
                                        : "#f9fafb",
                                    color:
                                      activeMarket === market.market_id
                                        ? "#fff"
                                        : "#111",
                                  }}
                                >
                                  {market.market}
                                </button>
                              ))}
                            </div>
                          )
                        );
                      })()}
                      <Row
                        style={{ paddingRight: "15px", paddingLeft: "15px" }}
                      >
                        {(() => {
                          // Only check for this specific game
                          if (
                            activeMatchTabName !== mainitem.eventName ||
                            activeTabName !== mainitem.displayDate
                          ) {
                            return null;
                          }

                          const filteredPlayers = fullist?.filter((player) =>
                            player?.name
                              ?.toLowerCase()
                              .includes(searchQuery?.toLowerCase() || '') &&
                            player?.markets?.some(
                              (market) => market?.market_id == activeMarket
                            )
                          );

                          if (filteredPlayers?.length === 0 && searchQuery) {
                            return (
                              <Col xs="12" className="text-center py-5">
                                <div style={{ 
                                  padding: "40px 20px",
                                  color: "#6b7280",
                                  fontSize: "16px"
                                }}>
                                  <i className="fa fa-search" style={{ fontSize: "48px", marginBottom: "16px", display: "block", color: "#d1d5db" }}></i>
                                  <h5 style={{ color: "#374151", marginBottom: "8px" }}>No players found</h5>
                                </div>
                              </Col>
                            );
                          }

                          return filteredPlayers?.map((item2) => {
                            let playerImage = "";
                            if (item2.image) {
                              playerImage = item2.image.includes("https://")
                                ? item2.image
                                : `${PlayerCardImageUrl}/${item2.image}`;
                            } else {
                              let defaultName = item2?.sportName
                                .replace(/\s/g, "")
                                .toLowerCase();
                              playerImage = `${PlayerCardImageUrl}/player/${defaultName}.png`;
                            }
                            if (
                              activeMatchTabName == mainitem.eventName &&
                              activeTabName == mainitem.displayDate
                            ) {
                              return (
                                <Col
                                  xs="12"
                                  lg="6"
                                  md="6"
                                  className="allplayers"
                                  style={{ padding: "5px" }}
                                  key={item2.id}
                                >
                                  <Card
                                    className="player-card"
                                    style={{
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                      padding: "0px",
                                      display: "flex",
                                      flexDirection: "column",
                                      // minHeight: "260px",  //comemnt this for the fix height of the box
                                      // height: "100%",//comemnt th
                                    }}
                                  >
                                    <Card.Body
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                        height: "100%",
                                      }}
                                    >
                                      <Row>
                                        <Col lg="4" xs="12">
                                          <img
                                            alt={item2.name}
                                            src={playerImage}
                                            className="player"
                                            style={{
                                              marginTop: "-8px",
                                              width: "100%",
                                              maxHeight: "110px",
                                              objectFit: "contain",
                                            }}
                                          />
                                        </Col>
                                        <Col
                                          lg="8"
                                          xs="12"
                                          className="mid-section"
                                        >
                                          <h5
                                            className="cardtext"
                                            style={{
                                              color: "#C02640",
                                              textTransform: "capitalize",
                                              fontWeight: "bold",
                                              fontSize: "18px",
                                            }}
                                          >
                                            {item2?.name}
                                          </h5>

                                          <h6
                                            style={{ fontWeight: "bold" }}
                                            className="cardtext cardtext-1"
                                          >
                                            <span className="red-player">
                                              {item2?.positionAbv}{" "}
                                            </span>
                                            <span>
                                              <span
                                                style={{ fontWeight: "normal" }}
                                              >
                                                |{" "}
                                              </span>
                                              {item2?.team_id == teamid
                                                ? hometeam
                                                : awayteam}{" "}
                                              {item2?.team_id == teamid
                                                ? "vs"
                                                : "@"}{" "}
                                              {item2?.team_id == teamid
                                                ? awayteam
                                                : hometeam}
                                            </span>
                                          </h6>
                                        </Col>
                                        <div
                                          className="w-full mt-2"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            flexGrow: 1,
                                          }}
                                        >
                                          {(() => {
                                            const marketData =
                                              item2.markets.find(
                                                (m) =>
                                                  m.market_id == activeMarket
                                              );

                                            const uniqueId = `${item2.id}_${mainitem.id}_${marketData?.marketId}`;

                                            const isExpanded =
                                              expandedPlayers[uniqueId] ||
                                              false;

                                            const toggleExpanded = (id) => {
                                              setExpandedPlayers((prev) => ({
                                                ...prev,
                                                [id]: !prev[id],
                                              }));
                                            };

                                            const oddsToShow =
                                              marketData?.odds || [];

                                            const marketsToShow = isExpanded
                                              ? oddsToShow
                                              : oddsToShow?.slice(0, 2);

                                            const isDisabled =
                                              newmarket.includes(
                                                `${item2.id}_${mainitem.id}_${marketData.marketId}`
                                              );

                                            //  const isDisabled = false;
                                            return (
                                              <>
                                                {marketsToShow?.map(
                                                  (playeritem, idx) => {
                                                    const oddId =
                                                      playeritem?.over?.id ||
                                                      playeritem?.under?.id;
                                                    const oddActive =
                                                      playeritem?.over
                                                        ?.active ||
                                                      playeritem?.under?.active;
                                                    const mainid = `${marketData?.id}_${item2?.id}_${CombineId}_${oddId}`;
                                                    const btnMore = `${mainid}_MORE`;
                                                    const btnLess = `${mainid}_LESS`;

                                                    if (!oddActive) {
                                                      return null;
                                                    }

                                                    const isMoreSelected =
                                                      selectedBetslipBtn.includes(
                                                        btnMore
                                                      );
                                                    const isLessSelected =
                                                      selectedBetslipBtn.includes(
                                                        btnLess
                                                      );

                                                    //  const isMultilineDisbaled = multiLinemarket.includes(`${marketData?.marketId}_${item2?.id}`) && !(isMoreSelected || isLessSelected);

                                                    const uniqueOddId = `${marketData?.id}_${item2?.id}_${CombineId}_${oddId}_${idx}`;

                                                    return (
                                                      <div
                                                        key={uniqueOddId}
                                                        className="row"
                                                      >
                                                        <div className="col-5 col-xs-12">
                                                          <h6
                                                            style={{
                                                              fontSize: "18px",
                                                              color: "#111827",
                                                              fontWeight: 700,
                                                              textAlign:
                                                                "initial",
                                                              marginBottom: 2,
                                                            }}
                                                          >
                                                            {
                                                              playeritem?.over
                                                                ?.points
                                                            }
                                                          </h6>
                                                          <h6
                                                            style={{
                                                              fontSize: "10px",
                                                              color: "#6b7280",
                                                              textAlign:
                                                                "initial",
                                                              textTransform:
                                                                "none",
                                                              marginTop: 0,
                                                              fontWeight: 600,
                                                            }}
                                                          >
                                                            {marketData?.market}
                                                          </h6>
                                                        </div>
                                                        <div
                                                          className="col-7"
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                            justifyContent:
                                                              "flex-end",
                                                          }}
                                                        >
                                                          <div
                                                            className="btngroup22"
                                                            style={{
                                                              display: "flex",
                                                              justifyContent:
                                                                "flex-end",
                                                              gap: "10px",
                                                            }}
                                                          >
                                                            {/* Less Button left side */}

                                                            {playeritem?.under &&
                                                              playeritem?.under
                                                                ?.active && (
                                                                <button
                                                                  className="btn btn-lower"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    padding:
                                                                      "7px 7px",
                                                                    marginBottom:
                                                                      "5px",
                                                                    width:
                                                                      "90px",
                                                                    borderRadius: 12,
                                                                    border:
                                                                      "1px solid #e5e7eb",
                                                                    backgroundColor:
                                                                      isDisabled
                                                                        ? "#ddd"
                                                                        : isLessSelected
                                                                        ? "#0D3862"
                                                                        : "#f9fafb",
                                                                    color:
                                                                      isDisabled
                                                                        ? "#999"
                                                                        : isLessSelected
                                                                        ? "#ffffff"
                                                                        : "#111827",
                                                                    boxShadow:
                                                                      "0 1px 2px rgba(0,0,0,0.04)",
                                                                  }}
                                                                  onClick={() => {
                                                                    if (
                                                                      isDisabled
                                                                    )
                                                                      return;
                                                                    // Remove higher if selected
                                                                    if (
                                                                      isMoreSelected
                                                                    ) {
                                                                      const idx =
                                                                        selectedBetslipBtn.indexOf(
                                                                          btnMore
                                                                        );
                                                                      if (
                                                                        idx > -1
                                                                      ) {
                                                                        dispatch(
                                                                          {
                                                                            type: Actions.REMOVE_SELECTED_BETSLIP,
                                                                            removeEleIndex:
                                                                              idx,
                                                                          }
                                                                        );
                                                                      }
                                                                    }

                                                                    handlechangePlayer(
                                                                      btnLess,
                                                                      {
                                                                        more: false,
                                                                        less: true,
                                                                        multiplier:
                                                                          playeritem
                                                                            ?.under
                                                                            ?.multiplier,
                                                                        price:
                                                                          playeritem
                                                                            ?.under
                                                                            ?.price,
                                                                        id: item2?.player_id,
                                                                        teamAid:
                                                                          mainitem
                                                                            ?.teamA
                                                                            ?.teamId ||
                                                                          "",
                                                                        teamAname:
                                                                          mainitem
                                                                            ?.teamA
                                                                            ?.abv ||
                                                                          "",
                                                                        teamHid:
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.teamId ||
                                                                          "",
                                                                        teamHname:
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.abv ||
                                                                          "",
                                                                        single_event:
                                                                          mainitem?.eventName,
                                                                        game_type:
                                                                          mainitem?.type,
                                                                        name: item2?.name,
                                                                        position:
                                                                          item2?.positionAbv,
                                                                        team: item2?.team_id,
                                                                        teamName:
                                                                          item2?.team_id ==
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.teamId
                                                                            ? mainitem
                                                                                ?.teamH
                                                                                ?.abv
                                                                            : mainitem
                                                                                ?.teamA
                                                                                ?.abv,
                                                                        image:
                                                                          item2?.image,
                                                                        points:
                                                                          playeritem
                                                                            ?.over
                                                                            ?.points,
                                                                        statName:
                                                                          marketData?.market,
                                                                        event_time:
                                                                          gameTime,
                                                                        event:
                                                                          mainitem?.startDate,
                                                                        sports:
                                                                          mainitem
                                                                            ?.sport
                                                                            ?.id,
                                                                        league:
                                                                          mainitem
                                                                            ?.league
                                                                            ?.id,
                                                                        marketId:
                                                                          marketData?.marketId,
                                                                        marketname:
                                                                          marketData?.market,
                                                                        statAbv:
                                                                          marketData?.marketAbv,
                                                                        correlatedmarket:
                                                                          marketData?.selectedMarket
                                                                            ? marketData?.selectedMarket
                                                                            : "",
                                                                        oj_ID:
                                                                          mainitem?.oj_ID,
                                                                        playerevent:
                                                                          {
                                                                            type: mainitem?.type,
                                                                            id: mainitem?.id,
                                                                            extId:
                                                                              mainitem?.extId,
                                                                            league:
                                                                              mainitem?.league,
                                                                            sport:
                                                                              mainitem?.sport,
                                                                            teamA:
                                                                              mainitem?.teamA,
                                                                            teamH:
                                                                              mainitem?.teamH,
                                                                          },
                                                                      },
                                                                      item2.id,
                                                                      mainitem.id
                                                                    );
                                                                  }}
                                                                >
                                                                  Less
                                                                  <br />
                                                                  <span
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                    }}
                                                                  >
                                                                    {
                                                                      playeritem
                                                                        ?.under
                                                                        ?.multiplier
                                                                    }
                                                                    {"x"}
                                                                    {/* ({playeritem?.under?.price}) */}
                                                                  </span>
                                                                </button>
                                                              )}

                                                            {/* More Button right side */}

                                                            {playeritem?.over &&
                                                              playeritem?.over
                                                                ?.active && (
                                                                <button
                                                                  className="btn btn-higher"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    padding:
                                                                      "7px 7px",
                                                                    marginBottom:
                                                                      "5px",
                                                                    width:
                                                                      "90px",
                                                                    borderRadius: 12,
                                                                    border:
                                                                      "1px solid #e5e7eb",
                                                                    backgroundColor:
                                                                      isDisabled
                                                                        ? "#ddd"
                                                                        : isMoreSelected
                                                                        ? "#0D3862"
                                                                        : "#f9fafb",
                                                                    color:
                                                                      isDisabled
                                                                        ? "#999"
                                                                        : isMoreSelected
                                                                        ? "#ffffff"
                                                                        : "#111827",
                                                                    boxShadow:
                                                                      "0 1px 2px rgba(0,0,0,0.04)",
                                                                  }}
                                                                  onClick={() => {
                                                                    if (
                                                                      isDisabled
                                                                    )
                                                                      return;

                                                                    // Remove lower if selected
                                                                    if (
                                                                      isLessSelected
                                                                    ) {
                                                                      const idx =
                                                                        selectedBetslipBtn.indexOf(
                                                                          btnLess
                                                                        );
                                                                      if (
                                                                        idx > -1
                                                                      ) {
                                                                        dispatch(
                                                                          {
                                                                            type: Actions.REMOVE_SELECTED_BETSLIP,
                                                                            removeEleIndex:
                                                                              idx,
                                                                          }
                                                                        );
                                                                      }
                                                                    }

                                                                    handlechangePlayer(
                                                                      btnMore,
                                                                      {
                                                                        more: true,
                                                                        less: false,
                                                                        multiplier:
                                                                          playeritem
                                                                            ?.over
                                                                            .multiplier,
                                                                        price:
                                                                          playeritem
                                                                            ?.over
                                                                            ?.price,
                                                                        id: item2?.player_id,
                                                                        teamAid:
                                                                          mainitem
                                                                            ?.teamA
                                                                            ?.teamId ||
                                                                          "",
                                                                        teamAname:
                                                                          mainitem
                                                                            ?.teamA
                                                                            ?.abv ||
                                                                          "",
                                                                        teamHid:
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.teamId ||
                                                                          "",
                                                                        teamHname:
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.abv ||
                                                                          "",
                                                                        single_event:
                                                                          mainitem?.eventName,
                                                                        game_type:
                                                                          mainitem?.type,
                                                                        name: item2?.name,
                                                                        position:
                                                                          item2?.positionAbv,
                                                                        team: item2?.team_id,
                                                                        teamName:
                                                                          item2?.team_id ==
                                                                          mainitem
                                                                            ?.teamH
                                                                            ?.teamId
                                                                            ? mainitem
                                                                                ?.teamH
                                                                                ?.abv
                                                                            : mainitem
                                                                                ?.teamA
                                                                                ?.abv,
                                                                        image:
                                                                          item2?.image,
                                                                        points:
                                                                          playeritem
                                                                            ?.over
                                                                            ?.points,
                                                                        statName:
                                                                          marketData?.market,
                                                                        event_time:
                                                                          gameTime,
                                                                        event:
                                                                          mainitem?.startDate,
                                                                        sports:
                                                                          mainitem
                                                                            ?.sport
                                                                            ?.id,
                                                                        league:
                                                                          mainitem
                                                                            ?.league
                                                                            ?.id,
                                                                        marketId:
                                                                          marketData?.marketId,
                                                                        marketname:
                                                                          marketData?.market,
                                                                        statAbv:
                                                                          marketData?.marketAbv,
                                                                        correlatedmarket:
                                                                          marketData.selectedMarket
                                                                            ? marketData.selectedMarket
                                                                            : "",
                                                                        oj_ID:
                                                                          mainitem?.oj_ID,
                                                                        playerevent:
                                                                          {
                                                                            type: mainitem?.type,
                                                                            id: mainitem?.id,
                                                                            extId:
                                                                              mainitem?.extId,
                                                                            league:
                                                                              mainitem?.league,
                                                                            sport:
                                                                              mainitem?.sport,
                                                                            teamA:
                                                                              mainitem?.teamA,
                                                                            teamH:
                                                                              mainitem?.teamH,
                                                                          },
                                                                      },
                                                                      item2.id,
                                                                      mainitem.id
                                                                    );
                                                                  }}
                                                                >
                                                                  More
                                                                  <br />
                                                                  <span
                                                                    style={{
                                                                      fontSize:
                                                                        "13px",
                                                                    }}
                                                                  >
                                                                    {
                                                                      playeritem
                                                                        ?.over
                                                                        ?.multiplier
                                                                    }
                                                                    {"x"}
                                                                    {/* ({playeritem?.over?.price}) */}
                                                                  </span>
                                                                </button>
                                                              )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                )}

                                                {/* Footer toggle bar like "More picks (9)" */}
                                                {marketData.odds?.length >
                                                  2 && (
                                                  <div
                                                    onClick={() =>
                                                      toggleExpanded(uniqueId)
                                                    }
                                                    role="button"
                                                    tabIndex={0}
                                                    onKeyDown={(e) =>
                                                      (e.key === "Enter" ||
                                                        e.key === " ") &&
                                                      toggleExpanded(uniqueId)
                                                    }
                                                    style={{
                                                      marginTop: "auto",
                                                      borderTop:
                                                        "1px solid #eee",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      padding: "12px 14px",
                                                      borderRadius:
                                                        "0 0 12px 12px",
                                                      background: "#fff",
                                                      cursor: "pointer",
                                                      fontWeight: 600,
                                                      color: "#1f2937",
                                                    }}
                                                  >
                                                    <span
                                                      style={{ fontSize: 16 }}
                                                    >
                                                      {isExpanded
                                                        ? "Show Fewer"
                                                        : `More Picks (${
                                                            marketData.odds
                                                              .length -
                                                            Math.min(
                                                              2,
                                                              marketData.odds
                                                                .length
                                                            )
                                                          })`}
                                                    </span>
                                                    <span
                                                      style={{
                                                        marginLeft: 8,
                                                        display: "inline-flex",
                                                        transform: isExpanded
                                                          ? "rotate(180deg)"
                                                          : "none",
                                                        transition:
                                                          "transform 0.2s ease",
                                                      }}
                                                    >
                                                      <BsFillCaretDownFill />
                                                    </span>
                                                  </div>
                                                )}
                                              </>
                                            );
                                          })()}
                                        </div>
                                      </Row>
                                    </Card.Body>
                                  </Card>
                                </Col>
                              );
                            } else {
                              return null;
                            }
                          });
                        })()}
                      </Row>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Col>
      ) : (
        <Col sm="12" lg="8">
          <div
            className="midbody bodyborder shail"
            style={{
              backgroundColor: "#E4E4E4",
              borderRadius: "10px",
              paddingTop: "5px",
              border: "2px solid #546779",
              marginLeft: "5px",
            }}
          >
            <NotFound />
          </div>
        </Col>
      )}
      {!isMobile && <MultiPlayerBetSlip />}
    </Row>
  );
};

export default MultiPlayerCard;
